import styled from 'styled-components'
import getTheme from '../../../themes'

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 32px;
  margin-top: 24px;
  @media (max-width: 1100px) { grid-template-columns: minmax(0, 1fr); }
`
export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`
export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  align-items: start;
  gap: 16px;
  @media (max-width: 600px) { grid-template-columns: minmax(0, 1fr); }
`
export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`
export const Summary = styled.aside`
  position: sticky;
  top: 24px;
  align-self: start;
  padding: 20px;
  border-radius: 8px;
  background: ${({theme}) => (theme as ReturnType<typeof getTheme>).palette[200]};
  overflow-wrap: anywhere;
  @media (max-width: 1100px) { position: static; }
`
export const Notice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid ${({theme}) => (theme as ReturnType<typeof getTheme>).palette[300]};
  border-radius: 8px;
  white-space: pre-line;
`
